var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t("contract.duration_and_resignation.headline")))]),_vm._v(" "),_vm._l((_vm.paragraphs),function(paragraph,index){return _c('p',{key:paragraph,staticClass:"user-output"},[_vm._v(_vm._s(("11." + (index + 1) + ".\t" + paragraph)))])}),_vm._v(" "),_c('hr')],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/contract/DurationAndResignationOutput.vue?vue&type=template&id=c9e6f046&
// module id = null
// module chunks = 